import { render, staticRenderFns } from "./LegalMarkdown.vue?vue&type=template&id=7bb4fe91"
import script from "./LegalMarkdown.vue?vue&type=script&lang=js"
export * from "./LegalMarkdown.vue?vue&type=script&lang=js"
import style0 from "./LegalMarkdown.vue?vue&type=style&index=0&id=7bb4fe91&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports